const BASE_URI = process.env.REACT_APP_API_ENDPOINT;

const BASE_PAYMENT_API = 'Payment';

const BASE_HEADERS = {};

const METHOD = {
	GET: 'get',
	POST: 'post',
	PUT: 'put',
};

const PAYMENT_API = {
	PAGE_SETTINGS: 'PageSettings',
	OVERVIEW: 'Overview',
	RESULT: 'Result',
	DO_PAYMENT: 'DoPayment',
};

export {
	BASE_URI,
	BASE_HEADERS,
	METHOD,
	BASE_PAYMENT_API,
	PAYMENT_API
};
